import { jsx as e, jsxs as c } from "react/jsx-runtime";
import g, { forwardRef as u } from "react";
import { c as d } from "./Section-DOeCOW54.js";
import { P as h } from "./Picture-JvtjNict.js";
import { T as f } from "./useMediaQuery-BZAMobKw.js";
import { M as w } from "./Modal-DQnpXu98.js";
import { S as _ } from "./ImageCarousel-rVtFRbaH.js";
import { b as x } from "./InfoCardGrid-CVf_t4co.js";
import { O as k, A as S } from "./ApartmentCard-BfyZfamk.js";
const b = g.forwardRef(
  ({ src: r, width: a, height: l, ...o }, s) => /* @__PURE__ */ e("iframe", { ref: s, src: r, width: a, height: l, ...o })
), y = "elo-desktop", m = {
  "large-image": "elo-large-image",
  "large-image__background": "elo-large-image__background",
  "large-image__image": "elo-large-image__image",
  "large-image__text-wrapper": "elo-large-image__text-wrapper",
  desktop: y,
  "large-image__cover": "elo-large-image__cover"
}, P = g.forwardRef(
  ({ imageUrl: r, alt: a, additionalText: l, buildingPage: o = !1, cover: s = !1, ...i }, t) => {
    const n = d(m["large-image__image"], {
      [m["large-image__background"]]: !o
    });
    return /* @__PURE__ */ c("div", { ref: t, ...i, className: n, children: [
      /* @__PURE__ */ e(
        h,
        {
          className: d(m["large-image__image"], {
            [m["large-image__cover"]]: s
          }),
          src: [
            {
              src: r,
              media: "(min-width:320px)"
            }
          ],
          alt: a || "",
          defaultSrc: r
        }
      ),
      l && /* @__PURE__ */ e("div", { className: m["large-image__text-wrapper"], children: /* @__PURE__ */ e(f, { type: "paragraph", size: "medium", children: l }) })
    ] });
  }
), v = {
  "iframe-modal__iframe": "elo-iframe-modal__iframe"
}, j = u(
  ({
    modalAriaDescription: r,
    modalAriaTitle: a,
    isOpen: l,
    onClose: o,
    src: s,
    ...i
  }, t) => /* @__PURE__ */ e(
    w,
    {
      ref: t,
      isOpen: l,
      onClose: o,
      modalAriaTitle: a,
      modalAriaDescription: r,
      size: "lightbox",
      ...i,
      children: /* @__PURE__ */ e(
        b,
        {
          src: s,
          className: v["iframe-modal__iframe"]
        }
      )
    }
  )
), p = {
  "card-carousel": "elo-card-carousel",
  "card-carousel__title": "elo-card-carousel__title"
}, O = g.forwardRef(
  ({ officeCardData: r, apartmentCardData: a, title: l }, o) => /* @__PURE__ */ c("div", { ref: o, className: p["card-carousel"], children: [
    /* @__PURE__ */ e(
      f,
      {
        type: "heading",
        size: "medium",
        extraClass: p["card-carousel__title"],
        children: l
      }
    ),
    /* @__PURE__ */ c(
      x,
      {
        autoPlay: !1,
        pauseButton: !1,
        slidesToShowMobile: 1.2,
        slidesToShowTablet: 2.3,
        slidesToShowDesktop: 3.2,
        slidesToShowLargeDesktop: 3.7,
        displayArrows: !0,
        speed: 700,
        children: [
          r && r.length > 0 && r.map((s, i) => /* @__PURE__ */ e(_, { children: /* @__PURE__ */ e(k, { ...s }) }, i)),
          a && a.length > 0 && a.map((s, i) => /* @__PURE__ */ e(_, { children: /* @__PURE__ */ e(S, { ...s }) }, i))
        ]
      }
    )
  ] })
);
export {
  O as C,
  j as I,
  P as L,
  b as a
};
